import React from 'react'
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs'
import { RedBadge, DarkBlueBadge } from '../data-card/data-card-parts'

import WorkOrderCommentsContainer from '../../containers/comments/work-order-comments-container'
import WorkOrderMessagesContainer from '../../containers/messages/work-order-messages-container'
import ServicingSummaryList from '../servicings/servicing-summary-list'
import ServicingSummaryContainer from '../../containers/servicings/servicing-summary-container'

export default ({
  workOrder,
  servicings,
  loadingServicings,
  onTabSelect,
  selectedTab,
  hasNextPage,
  onLoadNextPage
}) => {
  const undismissedMessagesCount = (workOrder.messagesCounts || {}).undismissed

  return (
  <Tabs className='tabs' onSelect={onTabSelect} selectedIndex={selectedTab}>
      <TabList>
        <Tab>Areas</Tab>
        <Tab>Comments <DarkBlueBadge text={workOrder.commentsCount} /></Tab>
        <Tab>
          Messages{' '}
          {undismissedMessagesCount > 0 &&
            <RedBadge text={undismissedMessagesCount} />
          }
        </Tab>
      </TabList>

      <TabPanel className='list'>
        {listServicings(servicings, workOrder, loadingServicings)}

        {hasNextPage &&
          <div className='card load-more' onClick={onLoadNextPage}>
            Load more...
          </div>}
      </TabPanel>

      <TabPanel>
        <WorkOrderCommentsContainer workOrderId={workOrder.id} unpinnable />
      </TabPanel>

      <TabPanel>
        <WorkOrderMessagesContainer workOrderId={workOrder.id} />
      </TabPanel>
    </Tabs>
  )
}

function listServicings (servicings, workOrder, loading) {
  if ((servicings || []).length) {
    return (
      <ServicingSummaryList>
        {servicings.map((servicing) => mapper(servicing, workOrder.id))}
      </ServicingSummaryList>
    )
  } else {
    return <p className='no-content'>{loading ? 'Loading...' : 'No areas found.'}</p>
  }
}

function mapper (servicing, workOrderId) {
  return (
    <ServicingSummaryContainer
      workOrderId={workOrderId}
      readonly
      canApprove
      canReopen
      canAddServices
      key={servicing.id}
      servicingId={servicing.id}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/work-summaries/work-summary-work-order-tabs-in-progress.js